var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var ContactFormView = Marionette.View.extend({
    template: require('../../templates/contacts/contact-form.html'),

    ui: {
        save: '#save-contact',
        type: '#contact-type',
        data: '#data',
        extension: '#extension',
        comment: '#comment',
        preferred: '#preferred',
        priority: '#priority',
        addresses: '#addresses',
        representatives: '#representatives',
        cancel: '#cancel-contact',
        usage: '#usage',
        dateFrom: '#date-from',
        dateTo: '#date-to'
    },

    events: {
        'click @ui.save': 'saveContact',
        'click @ui.cancel': 'cancel',
        'change @ui.type': 'typeChanged',
        'keyup @ui.data': 'dataChanged',
        'keyup @ui.extension': 'extensionChanged',
        'keyup @ui.comment': 'commentChanged',
        'click @ui.preferred': 'preferredChanged',
        'change @ui.priority': 'priorityChange',
        'change @ui.addresses': 'addressesChanged',
        'change @ui.representatives': 'representativesChanged',
        'change @ui.usage': 'usageChanged'
    },

    default: {
        contact: {
            type: "EMAIL",
            data: undefined,
            preferred: false,
            priority: 5,
            source: 'MANUAL',
            extension: null,
            addresses: [],
            comment: null,
            from: 0,
            to: 0,
            usage: null
        }
    },

    templateContext: function () {
        var dateFrom = this.contact.from == 0 ? '' : this.utils.longToDateTimeFormatted(Number(this.contact.from), 'MM/DD/YYYY');
        var dateTo = this.contact.to == 0 ? '' : this.utils.longToDateTimeFormatted(Number(this.contact.to), 'MM/DD/YYYY');
        return {
            title: this.mode == 'add' ? 'New Contact' : "Edit Contact",
            mode: this.mode == 'add' ? 'Add' : "Edit",
            contact: this.contact,
            addresses: this.addresses,
            representatives: this.representatives,
            contactTypes: this.utils.getContactTypes(),
            priorities: this.utils.getContactPriorities(),
            addressUsages: Dicts.addressUsages,
            dateFrom: dateFrom,
            dateTo: dateTo
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'saveContact', 'typeChanged', 'dataChanged', 'preferredChanged', 'priorityChange', 'addressesChanged', 'usageChanged', 'cancel');
        if (options) {
            this.contact = options.contact || _.clone(this.default.contact);
            this.contact.source = _.isEmpty(this.contact.source) ? 'MANUAL' : this.contact.source;
            this.mode = options.mode;
            this.addresses = options.addresses;
            this.representatives = options.representatives;
        }
        this.utils = new CommonUtils();
    },

    onRender: function () {
        this.ui.type.selectize({
            allowEmptyOption: false
        });
        this.ui.priority.selectize({
            allowEmptyOption: false
        });
        this.ui.addresses.selectize({
            allowEmptyOption: true
        });
        this.ui.representatives.selectize({
            allowEmptyOption: true
        });
        this.ui.usage.selectize({
            allowEmptyOption: false
        });

        this.ui.dateFrom.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });
        this.ui.dateTo.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });
    },

    saveContact: function () {
        if (_.isEmpty(this.contact.type)) {
            notificationsChannel.request('show:notification', 'The type of the contact must be set');
            return;
        }
        if (_.isEmpty(this.contact.data) && this.contact.type !== "REVIEW_AND_SIGN") {
            notificationsChannel.request('show:notification', 'The value of the contact must be set');
            return;
        }
        if (this.contact.type == "EMAIL" && !this.utils.isValidEmail(this.contact.data)) {
            notificationsChannel.request('show:notification', 'Invalid e-mail value');
            return;
        }

        if (!this.contact.priority) {
            this.contact.priority = this.default.contact.priority;
        }

        this.contact.from = this.utils.dateToLong(this.ui.dateFrom.val());
        this.contact.to = this.utils.dateToLong(this.ui.dateTo.val());

        this.triggerMethod('on:contact:saved', {mode: this.mode, contact: this.contact});
    },

    typeChanged: function (event) {
        this.contact.type = event.target.value;
    },

    dataChanged: function (event) {
        this.contact.data = event.target.value;
    },

    extensionChanged: function(event) {
        this.contact.extension = event.target.value;
    },

    commentChanged: function(event){
        this.contact.comment = event.target.value;
    },

    preferredChanged: function (event) {
        this.contact.preferred = event.target.checked;
    },

    addressChanged: function(event) {
        this.contact.address = event.target.value;
    },
    usageChanged: function (event) {
        this.contact.usage = event.target.value;
    },

    addressesChanged: function(event) {
        var that = this;
        this.contact.addresses = [];
        $("#addresses :selected").each(function(){
            that.contact.addresses.push($(this).val());
        });
    },

    representativesChanged: function() {
        var that = this;
        this.contact.representatives = [];
        $("#representatives :selected").each(function(){
            that.contact.representatives.push($(this).val());
        });
    },

    priorityChange: function(event) {
        this.contact.priority = event.target.value;
    },

    cancel: function () {
        this.triggerMethod('on:contact:action', {mode: 'cancel'});
    }

});

module.exports = ContactFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/contacts/contact-form.js
// module id = 254
// module chunks = 0